import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyles';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import About from './components/About/About';
import Experience from './components/Experience/Experience';
import Certifications from './components/Certifications/Certifications';
import Recommendations from './components/Recommendations/Recommendations';
import Contact from './components/Contact/Contact';

const theme = {
  colors: {
    primary: '#2563eb',
    secondary: '#1e40af',
    dark: '#1f2937',
    light: '#f3f4f6',
    gray: '#6b7280',
  },
  fonts: {
    primary: '"Poppins", sans-serif',
    secondary: '"Fira Code", monospace',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={
              <>
                <Home id="home" />
                <About id="about" />
                <Experience id="experience" />
                <Certifications id="certifications" />
                <Recommendations id="recommendations" />
                <Contact id="contact" />
              </>
          } />
          <Route path="*" element={<div>Page not found</div>} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
